import type { PropsWithChildren, ReactNode } from "react"
import { Divider, Paper, Stack, Typography } from "@mui/material"

interface ChartTooltipCardProps {
  /** What the values belong to, usually the hovered date. */
  title?: ReactNode
}

// Every chart tooltip: an optional title over the values, on the floating surface.
const ChartTooltipCard = ({
  title,
  children,
}: PropsWithChildren<ChartTooltipCardProps>) => {
  return (
    <Paper
      elevation={3}
      sx={[(theme) => theme.mixins.floatingSurface, { color: "text.secondary" }]}
    >
      {title && (
        <>
          <Stack py={1} px={2}>
            <Typography>{title}</Typography>
          </Stack>
          <Divider />
        </>
      )}
      <Stack py={1} px={2} spacing={1} width={"100%"}>
        {children}
      </Stack>
    </Paper>
  )
}

export default ChartTooltipCard
